import * as React from "react";
import { SVGProps } from "react";

const SvgTenSpades = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 251 351"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M241.2.2H10.6S.9.5.9 13.3v323.8c0 12.8 9.7 13.1 9.7 13.1h230.6s9.7-.3 9.7-13.1V13.2c-.1-12.8-9.7-13-9.7-13Z"
      fill="#fff"
    />
    <mask
      id="ten-spades_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={1}
      y={189}
      width={250}
      height={162}
    >
      <path
        d="M148.3 189c-49.1 0-98.2 0-147.3.1V337c0 12.8 9.7 13.1 9.7 13.1h230.5s9.7-.3 9.7-13.1V189H148.3Z"
        fill="url(#ten-spades_svg__a)"
      />
    </mask>
    <g mask="url(#ten-spades_svg__b)">
      <path
        d="M148.3 189c-49.1 0-98.2 0-147.3.1V337c0 12.8 9.7 13.1 9.7 13.1h230.5s9.7-.3 9.7-13.1V189H148.3Z"
        fill="url(#ten-spades_svg__c)"
      />
    </g>
    <mask
      id="ten-spades_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={251}
      height={175}
    >
      <path
        d="M.9 174.7h249.9V13.2C250.8.4 241.1.1 241.1.1H10.6S.9.4.9 13.2v161.5Z"
        fill="url(#ten-spades_svg__d)"
      />
    </mask>
    <g mask="url(#ten-spades_svg__e)">
      <path
        d="M.9 174.7h249.9V13.2C250.8.4 241.1.1 241.1.1H10.6S.9.4.9 13.2v161.5Z"
        fill="url(#ten-spades_svg__f)"
      />
    </g>
    <mask
      id="ten-spades_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={246}
      height={350}
    >
      <path
        d="M250.3 13.2v323.2c0 12.8-9.7 13-9.7 13H9.9s-2.1-.1-4.3-1.4c2.5 1.8 5.1 1.9 5.1 1.9h230.6s9.7-.3 9.7-13.1V13.2C251 .4 241.3.1 241.3.1h-.5c-.2 0 9.5.3 9.5 13.1Z"
        fill="url(#ten-spades_svg__g)"
      />
    </mask>
    <g mask="url(#ten-spades_svg__h)">
      <path
        d="M250.3 13.2v323.2c0 12.8-9.7 13-9.7 13H9.9s-2.1-.1-4.3-1.4c2.5 1.8 5.1 1.9 5.1 1.9h230.6s9.7-.3 9.7-13.1V13.2C251 .4 241.3.1 241.3.1h-.5c-.2 0 9.5.3 9.5 13.1Z"
        fill="url(#ten-spades_svg__i)"
      />
    </g>
    <mask
      id="ten-spades_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={247}
      height={351}
    >
      <path
        d="M1.4 336.9V13.7C1.4.9 11.1.7 11.1.7h230.8s2.1.1 4.3 1.4C243.7.3 241.1.2 241.1.2H10.6S.9.5.9 13.3v323.8c0 12.8 9.7 13.1 9.7 13.1h.5c0-.2-9.7-.5-9.7-13.3Z"
        fill="url(#ten-spades_svg__j)"
      />
    </mask>
    <g mask="url(#ten-spades_svg__k)">
      <path
        d="M1.4 336.9V13.7C1.4.9 11.1.7 11.1.7h230.8s2.1.1 4.3 1.4C243.7.3 241.1.2 241.1.2H10.6S.9.5.9 13.3v323.8c0 12.8 9.7 13.1 9.7 13.1h.5c0-.2-9.7-.5-9.7-13.3Z"
        fill="url(#ten-spades_svg__l)"
      />
      <mask
        id="ten-spades_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={2}
        height={303}
      >
        <path
          d="M.9 25.4v301.7c.2-.6.3-1.2.5-1.8V30.9c-.1-1.8-.3-3.6-.5-5.5Z"
          fill="url(#ten-spades_svg__m)"
        />
      </mask>
      <g mask="url(#ten-spades_svg__n)">
        <path
          d="M.9 25.4v301.7c.2-.6.3-1.2.5-1.8V30.9c-.1-1.8-.3-3.6-.5-5.5Z"
          fill="url(#ten-spades_svg__o)"
        />
      </g>
    </g>
    <path
      d="M25.9 67.3c-.5 6.5-4.2 11.1-4.2 11.1h8.4s-3.7-4.6-4.2-11.1Z"
      fill="#000"
    />
    <path
      d="M33.7 57.7c-5.2-3.6-7.8-7.4-7.9-7.5-.1.1-2.6 3.9-7.9 7.5-5.3 3.7-6.5 8.2-4.6 11.6 1.9 3.4 9.4 5.1 12.5-1.7 3 6.8 10.6 5.2 12.5 1.7 1.9-3.4.7-8-4.6-11.6ZM19.5 39.9c0 .9 0 1.5.1 1.9.1.4.3.8.5 1.1.2.3.6.5 1 .6.5.2 1 .3 1.7.4.7.1 1.6.1 2.7.2v1.6H9.2v-1.6c1.6-.1 2.8-.2 3.5-.3.7-.1 1.2-.3 1.6-.6.4-.3.6-.6.8-1.1.2-.5.3-1.2.3-2.2V22c0-.6-.1-1-.3-1.3-.2-.3-.5-.4-.9-.4-.5 0-1.1.2-2 .7-.9.5-1.9 1.2-3.2 2l-1-1.7 10.3-6.2h1.2c-.1 1.4-.1 3.4-.1 5.9v18.9h.1ZM33.8 46c-3.2 0-5.5-1.3-7.1-3.8-1.6-2.5-2.3-6.3-2.3-11.4 0-2.7.2-5 .7-7 .5-2 1.1-3.6 2-4.9.9-1.3 1.9-2.2 3.1-2.9 1.2-.6 2.5-.9 4-.9 3.2 0 5.6 1.2 7.2 3.7 1.6 2.5 2.4 6.3 2.4 11.3 0 5.2-.8 9.2-2.5 11.8-1.8 2.8-4.3 4.1-7.5 4.1Zm-5.1-15.8c0 4.8.4 8.3 1.3 10.6.9 2.2 2.3 3.4 4.1 3.4 1.8 0 3.1-1.1 4-3.2.9-2.1 1.3-5.4 1.3-9.8 0-3.4-.2-6.1-.7-8.2-.4-2.1-1.1-3.6-1.8-4.5-.8-.9-1.7-1.4-2.9-1.4-1 0-1.9.3-2.6.9-.7.6-1.2 1.5-1.7 2.6-.4 1.1-.7 2.5-.9 4.1-.1 1.6-.1 3.5-.1 5.5ZM226.6 282.2c.5-6.5 4.2-11.1 4.2-11.1h-8.4c-.1 0 3.6 4.6 4.2 11.1Z"
      fill="#000"
    />
    <path
      d="M218.7 291.8c5.2 3.6 7.8 7.4 7.9 7.5.1-.1 2.6-3.9 7.9-7.5 5.3-3.7 6.5-8.2 4.6-11.6-1.9-3.4-9.4-5.1-12.5 1.7-3-6.8-10.6-5.2-12.5-1.7-1.9 3.4-.7 8 4.6 11.6ZM233 309.6c0-.9 0-1.5-.1-1.9-.1-.4-.3-.8-.5-1.1-.2-.3-.6-.5-1-.6-.5-.2-1-.3-1.7-.4-.7-.1-1.6-.1-2.7-.2v-1.6h16.3v1.6c-1.6.1-2.8.2-3.5.3-.7.1-1.2.3-1.6.6-.4.3-.6.6-.8 1.1-.2.5-.3 1.2-.3 2.2v17.9c0 .6.1 1 .3 1.3.2.3.5.4.9.4.5 0 1.1-.2 2-.7.9-.5 1.9-1.2 3.2-2l1 1.7-10.3 6.2H233c.1-1.4.1-3.4.1-5.9v-18.9h-.1ZM218.7 303.5c3.2 0 5.5 1.3 7.1 3.8 1.6 2.5 2.3 6.3 2.3 11.4 0 2.7-.2 5-.7 7-.5 2-1.1 3.6-2 4.9-.9 1.3-1.9 2.2-3.1 2.9-1.2.6-2.5.9-4 .9-3.2 0-5.6-1.2-7.2-3.7-1.6-2.5-2.4-6.3-2.4-11.3 0-5.2.8-9.2 2.5-11.8 1.8-2.8 4.2-4.1 7.5-4.1Zm5.1 15.8c0-4.8-.4-8.3-1.3-10.6-.9-2.2-2.3-3.4-4.1-3.4-1.8 0-3.1 1.1-4 3.2-.9 2.1-1.3 5.4-1.3 9.8 0 3.4.2 6.1.7 8.2.4 2.1 1.1 3.6 1.8 4.5.8.9 1.7 1.4 2.9 1.4 1 0 1.9-.3 2.6-.9.7-.6 1.2-1.5 1.7-2.6.4-1.1.7-2.5.9-4.1 0-1.6.1-3.4.1-5.5ZM171.6 201.3c1.1-12.9 8.4-21.9 8.4-21.9h-16.8s7.3 9 8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M156 220.4c10.4 7.2 15.5 14.6 15.6 14.8.1-.2 5.2-7.7 15.6-14.8 10.5-7.2 12.9-16.3 9.1-23.1-3.8-6.8-18.8-10.1-24.7 3.4-6-13.5-21-10.2-24.7-3.4-3.8 6.8-1.4 15.9 9.1 23.1ZM171.6 265.6c-1.1-12.9-8.4-21.9-8.4-21.9H180c-.1 0-7.3 9-8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M187.2 284.7c-10.3 7.2-15.5 14.6-15.6 14.8-.1-.2-5.2-7.7-15.6-14.8-10.5-7.2-12.9-16.3-9.1-23.1 3.8-6.8 18.8-10.1 24.7 3.4 6-13.5 21-10.2 24.7-3.4 3.7 6.9 1.4 15.9-9.1 23.1ZM171.6 84.7c-1.1 12.9-8.4 21.9-8.4 21.9H180c-.1 0-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M187.2 65.5c-10.4-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.7-6.8 1.4-15.8-9.1-23.1ZM171.6 149c-1.1 12.9-8.4 21.9-8.4 21.9H180c-.1 0-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M187.2 129.9c-10.4-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.7-6.8 1.4-15.9-9.1-23.1ZM80.2 201.3c1.1-12.9 8.4-21.9 8.4-21.9H71.8s7.3 9 8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M64.6 220.4c10.3 7.2 15.5 14.6 15.6 14.8.1-.2 5.2-7.7 15.6-14.8 10.5-7.2 12.9-16.3 9.1-23.1-3.8-6.8-18.8-10.1-24.7 3.4-6-13.5-21-10.2-24.7-3.4-3.8 6.8-1.4 15.9 9.1 23.1ZM80.2 265.6c-1.1-12.9-8.4-21.9-8.4-21.9h16.8c-.1 0-7.3 9-8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M95.8 284.7c-10.4 7.2-15.5 14.6-15.6 14.8-.1-.2-5.2-7.7-15.6-14.8-10.5-7.2-12.9-16.3-9.1-23.1 3.8-6.8 18.8-10.1 24.7 3.4 6-13.5 21-10.2 24.7-3.4 3.8 6.9 1.4 15.9-9.1 23.1ZM80.2 84.7c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c-.1 0-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M95.8 65.5c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.8-9.1-23.1ZM80.2 149c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c-.1 0-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M95.8 129.9c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.9-9.1-23.1ZM125.9 115c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c-.1.1-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M141.5 95.9c-10.4-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.9-9.1-23.1ZM125.9 230.6c-1.1-12.9-8.4-21.9-8.4-21.9h16.8c-.1-.1-7.3 9-8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M141.5 249.7c-10.4 7.2-15.5 14.6-15.6 14.8-.1-.2-5.2-7.7-15.6-14.8-10.5-7.2-12.9-16.3-9.1-23.1 3.8-6.8 18.8-10.1 24.7 3.4 6-13.5 21-10.2 24.7-3.4 3.8 6.8 1.4 15.9-9.1 23.1Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="ten-spades_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(122.014 -119.116) scale(505.879)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(122.014 -119.116) scale(505.879)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(127.018 322.985) scale(362.494)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(127.018 322.985) scale(362.494)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.752 -.008) scale(402.495)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.752 -.008) scale(402.495)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.193 101.964) scale(342.818)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.193 101.964) scale(342.818)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 130.689 -.005) scale(402.421)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="ten-spades_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 130.689 -.005) scale(402.421)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgTenSpades;
